import { FileListItem } from "@/components/IBFile/interface";

export type TText = string | number | null | undefined

export type TSrc = string | null

export enum EActionType {
	button = 'button',
	submit = 'submit'
}

export enum KeyPageHistory {
	ACCOUNT = 'ACCOUNT',
	PAYROLL = 'PAYROLL',
	SWIFT = 'SWIFT',
	FOREIGN_EXCHANGE = 'FOREIGN_EXCHANGE',
}

export enum EColorState {
	primary = 'primary',
	secondary = 'secondary',
	success = 'success',
	info = 'info',
	danger = 'danger',
	danger_outlined = 'danger_outlined',
	light = 'light',
	warning = 'warning',
	dark = 'dark',
	link = 'link',
	default = 'default',
	primary_second = 'primary_second',
}

export enum PaymentCardVariant {
	secondary = 'secondary',
}

export enum PaymentCardIconSize {
	large = 'large',
}

export interface IIcon {
	src?: TSrc
	font?: string
	type?: EColorState
}

export interface IAction {
	type?: EActionType
	color?: EColorState
	prependIcon?: IIcon
	appendIcon?: IIcon
	text?: TText
	subText?: TText
	action?: () => void
	disabled?: boolean
}

export interface ICheckbox {
	checked: boolean
	action?: (value: boolean) => void
	visibility?: boolean
	hideIsResolution?: 'isSm'
		| 'isMd'
		| 'isLg'
}

export interface IPaymentCardLabel {
	title?: TText
	text?: TText
}

export interface IPaymentCardListItem extends IPaymentCardLabel {
	heading?: TText
	textColor?: EColorState
}

export interface IPaymentCardHeading {
	text: TText
	type?: EColorState
}

export interface IPaymentCardHeadingRight {
	text: TText
	type?: EColorState
}

export interface IChip extends IPaymentCardHeading {
	action?: () => void
}

export interface IPaymentCardActions {
	left?: Array<IAction>
	right?: Array<IAction>
}

export interface IPaymentCardMobile {
	label?: TText
}

export interface IPaymentCardContentIcon extends IIcon {
	withoutBg?: boolean
	size?: PaymentCardIconSize
}

export interface IPaymentCardContent {
	icon?: IPaymentCardContentIcon
	chips?: Array<IChip>
	list?: Array<IPaymentCardListItem>
	listRight?: Array<IPaymentCardListItem>
	label?: IPaymentCardLabel
	subTitle?: TText
	files?: FileListItem[]
	loading?: boolean
	contentAmount?: TText
	contentAfterAmount?: TText
}

export interface IPaymentCardIcon extends IIcon {
	hideIfCheckboxVisible?: boolean
}

export interface IPaymentCardRegisterContent {
	title?: string
	leftText?: string
	accountNumber?: string
	imgCoin?: string
	imgDownload?: string
	fileName?: string
	downloadRegistry?: any
}

export interface IPaymentCard<T = any> {
	isReasonReturn?: boolean;
	rejectedReason?: string | null;
	errorPayment?: boolean;
	errorText?: string;
	outgoingPaymentStatus?: string;
	munisType?: boolean;
	isHistoryTypeMunis?: boolean;
	isPriceCenterY?: boolean;
	registerType?: boolean;
	registerContent?: IPaymentCardRegisterContent;
	contentAmount?: TText;
	dataDoc?: string;
	accountHistoryState?: number;
	payrollHistoryState?: string;
	swiftHistoryState?: number;
	foreignExchangeStatus?: string;
	typePage?: KeyPageHistory;
	meta?: T;
	overline?: TText;
	heading?: IPaymentCardHeading;
	headingRight?: IPaymentCardHeadingRight;
	isHistoryType?: boolean;
	isForexHistory?: boolean;
	disableSlice?: boolean;
	isHistoryTypePyroll?: boolean;
	isHistoryTypeSwift?: boolean;
	payrollUserId?: any;
	payrollUser?: any;
	title?: TText;
	titleColor?: EColorState;
	titleIcon?: string;
	subTitle?: TText;
	country?: TText;
	paymentSystem?: string | number;
	caption?: TText;
	bottomTitle?: TText;
	bottomTitleColor?: EColorState;
	bottomComment?: TText;
	dateTime?: number;
	checkbox?: ICheckbox;
	expanded?: boolean;
	dense?: boolean;
	isExpandable?: boolean;
	action?: (value: boolean) => void;
	icon?: IPaymentCardIcon;
	amount?: TText;
	showAmountInHead?: boolean;
	currency?: TText;
	content?: IPaymentCardContent;
	actions?: IPaymentCardActions;
	mobile?: IPaymentCardMobile;
	showPositiveAmount?: boolean;
	imgSubText?: TText;
	variant?: PaymentCardVariant;
	isRegisterOperation?: boolean;
	registerId?: number;
	register?: any;
	simpleColor?: boolean;
	paymentType?: string;
	hidden?: boolean;
	btnDelete?: boolean;
	id?: number;
}

export interface IPaymentCardFormattedAmount {
	main: string
	sub: string
}
